import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: Date;
  GenericScalar: any;
  StringDateTime: any;
  Upload: any;
};

export type AddVesselToFavoriteMutation = {
  nope: Maybe<Scalars['Boolean']>;
};

export type Admission = {
  accessZone1: Maybe<Scalars['Boolean']>;
  accessZone2: Maybe<Scalars['Boolean']>;
  accessZone3: Maybe<Scalars['Boolean']>;
  actualAddress: Maybe<Scalars['String']>;
  birthDate: Maybe<Scalars['Date']>;
  birthPlace: Maybe<Scalars['String']>;
  carBrand: Maybe<Scalars['String']>;
  carColor: Maybe<Scalars['String']>;
  carModel: Maybe<Scalars['String']>;
  carRegNumber: Maybe<Scalars['String']>;
  carType: Maybe<Scalars['Int']>;
  chiefFullName: Maybe<Scalars['String']>;
  chiefPhone: Maybe<Scalars['String']>;
  companyActivityKind: Maybe<Scalars['String']>;
  companyName: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  fullName: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  inn: Maybe<Scalars['String']>;
  paragraph: Maybe<Scalars['Int']>;
  passDate: Maybe<Scalars['String']>;
  passportDate: Maybe<Scalars['Date']>;
  passportDepartmentCode: Maybe<Scalars['String']>;
  passportIssuer: Maybe<Scalars['String']>;
  passportNumber: Maybe<Scalars['String']>;
  passportSeries: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  position: Maybe<Scalars['String']>;
  registrationAddress: Maybe<Scalars['String']>;
  status: Maybe<Scalars['Int']>;
};

export type AdmissionInput = {
  accessZone2: Scalars['Boolean'];
  accessZone3: Scalars['Boolean'];
  actualAddress: InputMaybe<Scalars['String']>;
  birthDate: InputMaybe<Scalars['Date']>;
  birthPlace: InputMaybe<Scalars['String']>;
  carBrand: InputMaybe<Scalars['String']>;
  carColor: InputMaybe<Scalars['String']>;
  carModel: InputMaybe<Scalars['String']>;
  carRegNumber: InputMaybe<Scalars['String']>;
  carType: InputMaybe<Scalars['Int']>;
  chiefFullName: Scalars['String'];
  chiefPhone: Scalars['String'];
  companyActivityKind: Scalars['String'];
  documents: InputMaybe<Array<InputMaybe<Scalars['Upload']>>>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  paragraph: Scalars['Int'];
  passDate: Scalars['String'];
  passportDate: Scalars['Date'];
  passportIssuer: Scalars['String'];
  passportNumber: Scalars['String'];
  passportSeries: Scalars['String'];
  phone: Scalars['String'];
  position: Scalars['String'];
  registrationAddress: InputMaybe<Scalars['String']>;
};

export enum AdmissionTypeEnum {
  Car = 'CAR',
  Pedestrian = 'PEDESTRIAN'
}

export type Car = {
  brand: Scalars['String'];
  color: Scalars['String'];
  id: Scalars['ID'];
  model: Scalars['String'];
  regNumber: Scalars['String'];
  search: Scalars['String'];
  type: Scalars['String'];
  uniqueKey: Scalars['String'];
};

export type Company = {
  chiefFullName: Scalars['String'];
  chiefPhone: Scalars['String'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  name: Scalars['String'];
};

export type CreateAdmissionMutation = {
  admission: Maybe<Admission>;
};

export type CreateServiceInterviewInput = {
  comment: InputMaybe<Scalars['String']>;
  rating: InputMaybe<Scalars['Int']>;
  serviceId: InputMaybe<Scalars['String']>;
  serviceVersion: InputMaybe<Scalars['String']>;
};

export type CreateServiceInterviewMutation = {
  nope: Maybe<Scalars['Boolean']>;
};

export type Employee = {
  actualAddress: Maybe<Scalars['String']>;
  birthDate: Maybe<Scalars['Date']>;
  birthPlace: Maybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  passportDate: Scalars['Date'];
  passportIssuer: Scalars['String'];
  passportNumber: Scalars['String'];
  passportSeries: Scalars['String'];
  phone: Scalars['String'];
  position: Scalars['String'];
  registrationAddress: Maybe<Scalars['String']>;
  search: Scalars['String'];
  uniqueKey: Scalars['String'];
};

export type ListPageInfo = {
  countItems: Maybe<Scalars['Int']>;
  nextPage: Maybe<Scalars['String']>;
  pageSize: Maybe<Scalars['Int']>;
};

export type Mutation = {
  addFavoriteVessel: Maybe<AddVesselToFavoriteMutation>;
  createAdmission: Maybe<CreateAdmissionMutation>;
  createServiceInterview: Maybe<CreateServiceInterviewMutation>;
  reachTarget: Maybe<ReachTargetMutation>;
  removeFavoriteVessel: Maybe<RemoveVesselFromFavoriteMutation>;
  subscribePush: Maybe<SubscribePushMutation>;
  syncPushSubscription: Maybe<SyncPushSubscriptionMutation>;
  unsubscribePush: Maybe<UnsubscribePushMutation>;
};


export type MutationAddFavoriteVesselArgs = {
  imo: Scalars['String'];
};


export type MutationCreateAdmissionArgs = {
  admission: AdmissionInput;
  types?: InputMaybe<Array<InputMaybe<AdmissionTypeEnum>>>;
};


export type MutationCreateServiceInterviewArgs = {
  serviceInterview?: InputMaybe<CreateServiceInterviewInput>;
};


export type MutationReachTargetArgs = {
  params?: InputMaybe<Scalars['GenericScalar']>;
  target?: InputMaybe<Scalars['String']>;
};


export type MutationRemoveFavoriteVesselArgs = {
  imo: Scalars['String'];
};


export type MutationSubscribePushArgs = {
  subscription?: InputMaybe<PushSubscriptionInput>;
};


export type MutationSyncPushSubscriptionArgs = {
  subscription?: InputMaybe<PushSubscriptionInput>;
};


export type MutationUnsubscribePushArgs = {
  subscription?: InputMaybe<PushSubscriptionInput>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']>;
};

export type PushSubscriptionInput = {
  authKey: Scalars['String'];
  endpoint: Scalars['String'];
  p256dhKey: Scalars['String'];
  userAgent: InputMaybe<Scalars['String']>;
};

export type Query = {
  admissionCars: Maybe<Array<Car>>;
  admissionCompany: Maybe<Company>;
  admissionEmployers: Maybe<Array<Employee>>;
  admissions: Maybe<Array<Maybe<Admission>>>;
  favoriteVessels: Maybe<Array<Maybe<Scalars['String']>>>;
  latestReleaseNote: Maybe<ReleaseNote>;
  ok: Maybe<Scalars['Boolean']>;
  reactions: Maybe<Scalars['GenericScalar']>;
  releaseNote: Maybe<ReleaseNote>;
  releaseNotes: Maybe<ReleaseNoteNodeConnection>;
  subscribePushSettings: Maybe<SubscribePushSettings>;
  vesselCall: Maybe<VesselCall>;
  vesselCalls: Maybe<VesselCallList>;
};


export type QueryAdmissionCarsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAdmissionEmployersArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAdmissionsArgs = {
  isAuto?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryReleaseNoteArgs = {
  version: Scalars['String'];
};


export type QueryReleaseNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryVesselCallArgs = {
  id: Scalars['String'];
};


export type QueryVesselCallsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ReachTargetMutation = {
  reactions: Maybe<Scalars['GenericScalar']>;
};

export type ReleaseNote = {
  content: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type ReleaseNoteNode = Node & {
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type ReleaseNoteNodeConnection = {
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReleaseNoteNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ReleaseNoteNode` and its cursor. */
export type ReleaseNoteNodeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node: Maybe<ReleaseNoteNode>;
};

export type RemoveVesselFromFavoriteMutation = {
  nope: Maybe<Scalars['Boolean']>;
};

export type SubscribePushMutation = {
  nope: Maybe<Scalars['Boolean']>;
};

export type SubscribePushSettings = {
  serverKey: Scalars['String'];
};

export type SyncPushSubscriptionMutation = {
  remove: Maybe<Scalars['Boolean']>;
};

export type UnsubscribePushMutation = {
  nope: Maybe<Scalars['Boolean']>;
};

export type VesselCall = {
  arrival: Maybe<VesselCallDirection>;
  date: Maybe<Scalars['StringDateTime']>;
  departure: Maybe<VesselCallDirection>;
  favorite: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  number: Maybe<Scalars['String']>;
  operations: Maybe<Array<Maybe<VesselCallOperation>>>;
  /** Ожидается | Завершен | В порту | На рейде */
  status: Maybe<Scalars['String']>;
  /** Линейный | Трамповый */
  type: Maybe<Scalars['String']>;
  vessel: Maybe<VesselCallVessel>;
};

export type VesselCallDirection = {
  date: Maybe<Scalars['StringDateTime']>;
  line: Maybe<Scalars['String']>;
  port: Maybe<VesselCallDirectionPort>;
  type: Maybe<Scalars['String']>;
  voyage: Maybe<Scalars['String']>;
};

export type VesselCallDirectionPort = {
  code: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type VesselCallList = {
  emptyFavorites: Maybe<Scalars['Boolean']>;
  pageInfo: Maybe<ListPageInfo>;
  vesselCalls: Maybe<Array<Maybe<VesselCallShort>>>;
};

export type VesselCallOperation = {
  berth: Maybe<Scalars['String']>;
  date: Maybe<Scalars['StringDateTime']>;
  operation: Maybe<Scalars['String']>;
  terminal: Maybe<Scalars['String']>;
};

export type VesselCallShort = {
  arrival: Maybe<VesselCallShortDirection>;
  date: Maybe<Scalars['StringDateTime']>;
  departure: Maybe<VesselCallShortDirection>;
  favorite: Maybe<Scalars['Boolean']>;
  id: Maybe<Scalars['ID']>;
  number: Maybe<Scalars['String']>;
  /** Ожидается | Завершен | В порту | На рейде */
  status: Maybe<Scalars['String']>;
  /** Линейный | Трамповый */
  type: Maybe<Scalars['String']>;
  vessel: Maybe<VesselCallShortVessel>;
};

export type VesselCallShortDirection = {
  date: Maybe<Scalars['StringDateTime']>;
  type: Maybe<Scalars['String']>;
  voyage: Maybe<Scalars['String']>;
};

export type VesselCallShortVessel = {
  imo: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type VesselCallVessel = {
  callSign: Maybe<Scalars['String']>;
  imo: Maybe<Scalars['String']>;
  length: Maybe<Scalars['String']>;
  line: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type GetAdmissionListQueryVariables = Exact<{
  query: InputMaybe<Scalars['String']>;
  isAuto: InputMaybe<Scalars['Boolean']>;
  statuses: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetAdmissionListQueryResult = { admissions: Array<{ id: string | null, status: number | null, companyName: string | null, inn: string | null, chiefFullName: string | null, chiefPhone: string | null, fullName: string | null, position: string | null, phone: string | null, email: string | null, birthDate: any | null, birthPlace: string | null, passportSeries: string | null, passportNumber: string | null, passportDate: any | null, passportIssuer: string | null, passportDepartmentCode: string | null, registrationAddress: string | null, actualAddress: string | null, carRegNumber: string | null, carBrand: string | null, carModel: string | null, carColor: string | null, carType: number | null, passDate: string | null, companyActivityKind: string | null, paragraph: number | null, accessZone1: boolean | null, accessZone2: boolean | null, accessZone3: boolean | null } | null> | null };

export type AdmissionFragment = { id: string | null, status: number | null, companyName: string | null, inn: string | null, chiefFullName: string | null, chiefPhone: string | null, fullName: string | null, position: string | null, phone: string | null, email: string | null, birthDate: any | null, birthPlace: string | null, passportSeries: string | null, passportNumber: string | null, passportDate: any | null, passportIssuer: string | null, passportDepartmentCode: string | null, registrationAddress: string | null, actualAddress: string | null, carRegNumber: string | null, carBrand: string | null, carModel: string | null, carColor: string | null, carType: number | null, passDate: string | null, companyActivityKind: string | null, paragraph: number | null, accessZone1: boolean | null, accessZone2: boolean | null, accessZone3: boolean | null };

export type CreateAdmissionMutationVariables = Exact<{
  admissionCar: AdmissionInput;
  admissionPedestrian: AdmissionInput;
}>;


export type CreateAdmissionMutationResult = { CAR: { admission: { id: string | null, status: number | null, companyName: string | null, inn: string | null, chiefFullName: string | null, chiefPhone: string | null, fullName: string | null, position: string | null, phone: string | null, email: string | null, birthDate: any | null, birthPlace: string | null, passportSeries: string | null, passportNumber: string | null, passportDate: any | null, passportIssuer: string | null, passportDepartmentCode: string | null, registrationAddress: string | null, actualAddress: string | null, carRegNumber: string | null, carBrand: string | null, carModel: string | null, carColor: string | null, carType: number | null, passDate: string | null, companyActivityKind: string | null, paragraph: number | null, accessZone1: boolean | null, accessZone2: boolean | null, accessZone3: boolean | null } | null } | null, PEDESTRIAN: { admission: { id: string | null, status: number | null, companyName: string | null, inn: string | null, chiefFullName: string | null, chiefPhone: string | null, fullName: string | null, position: string | null, phone: string | null, email: string | null, birthDate: any | null, birthPlace: string | null, passportSeries: string | null, passportNumber: string | null, passportDate: any | null, passportIssuer: string | null, passportDepartmentCode: string | null, registrationAddress: string | null, actualAddress: string | null, carRegNumber: string | null, carBrand: string | null, carModel: string | null, carColor: string | null, carType: number | null, passDate: string | null, companyActivityKind: string | null, paragraph: number | null, accessZone1: boolean | null, accessZone2: boolean | null, accessZone3: boolean | null } | null } | null };

export type CreateCarAdmissionMutationVariables = Exact<{
  admission: AdmissionInput;
}>;


export type CreateCarAdmissionMutationResult = { CAR: { admission: { id: string | null, status: number | null, companyName: string | null, inn: string | null, chiefFullName: string | null, chiefPhone: string | null, fullName: string | null, position: string | null, phone: string | null, email: string | null, birthDate: any | null, birthPlace: string | null, passportSeries: string | null, passportNumber: string | null, passportDate: any | null, passportIssuer: string | null, passportDepartmentCode: string | null, registrationAddress: string | null, actualAddress: string | null, carRegNumber: string | null, carBrand: string | null, carModel: string | null, carColor: string | null, carType: number | null, passDate: string | null, companyActivityKind: string | null, paragraph: number | null, accessZone1: boolean | null, accessZone2: boolean | null, accessZone3: boolean | null } | null } | null };

export type CreatePedestrianAdmissionMutationVariables = Exact<{
  admission: AdmissionInput;
}>;


export type CreatePedestrianAdmissionMutationResult = { PEDESTRIAN: { admission: { id: string | null, status: number | null, companyName: string | null, inn: string | null, chiefFullName: string | null, chiefPhone: string | null, fullName: string | null, position: string | null, phone: string | null, email: string | null, birthDate: any | null, birthPlace: string | null, passportSeries: string | null, passportNumber: string | null, passportDate: any | null, passportIssuer: string | null, passportDepartmentCode: string | null, registrationAddress: string | null, actualAddress: string | null, carRegNumber: string | null, carBrand: string | null, carModel: string | null, carColor: string | null, carType: number | null, passDate: string | null, companyActivityKind: string | null, paragraph: number | null, accessZone1: boolean | null, accessZone2: boolean | null, accessZone3: boolean | null } | null } | null };

export type GetAdmissionCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdmissionCompanyQueryResult = { admissionCompany: { name: string, inn: string, chiefFullName: string, chiefPhone: string } | null };

export type GetAdmissionEmployeeListQueryVariables = Exact<{
  query: InputMaybe<Scalars['String']>;
}>;


export type GetAdmissionEmployeeListQueryResult = { admissionEmployers: Array<{ fullName: string, passportSeries: string, passportNumber: string, passportIssuer: string, passportDate: any, birthDate: any | null, birthPlace: string | null, registrationAddress: string | null, actualAddress: string | null, phone: string, email: string, position: string }> | null };

export type GetAdmissionCarListQueryVariables = Exact<{
  query: InputMaybe<Scalars['String']>;
}>;


export type GetAdmissionCarListQueryResult = { admissionCars: Array<{ brand: string, type: string, model: string, regNumber: string, color: string }> | null };

export type GetVesselCallListQueryVariables = Exact<{
  dateFrom: InputMaybe<Scalars['Date']>;
  dateTo: InputMaybe<Scalars['Date']>;
  status: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  favorite: InputMaybe<Scalars['Boolean']>;
  page: InputMaybe<Scalars['String']>;
}>;


export type GetVesselCallListQueryResult = { vesselCalls: { emptyFavorites: boolean | null, vesselCalls: Array<{ id: string | null, date: any | null, number: string | null, type: string | null, status: string | null, favorite: boolean | null, vessel: { name: string | null, imo: string | null } | null, arrival: { date: any | null, type: string | null, voyage: string | null } | null, departure: { date: any | null, type: string | null, voyage: string | null } | null } | null> | null, pageInfo: { countItems: number | null, nextPage: string | null, pageSize: number | null } | null } | null };

export type GetVesselCallQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetVesselCallQueryResult = { vesselCall: { id: string | null, date: any | null, number: string | null, type: string | null, status: string | null, favorite: boolean | null, vessel: { name: string | null, imo: string | null, callSign: string | null, line: string | null, length: string | null } | null, arrival: { date: any | null, type: string | null, voyage: string | null, line: string | null, port: { code: string | null, name: string | null } | null } | null, departure: { date: any | null, type: string | null, voyage: string | null, line: string | null, port: { code: string | null, name: string | null } | null } | null, operations: Array<{ date: any | null, operation: string | null, terminal: string | null, berth: string | null } | null> | null } | null };

export type FollowVesselMutationVariables = Exact<{
  imo: Scalars['String'];
}>;


export type FollowVesselMutationResult = { addFavoriteVessel: { nope: boolean | null } | null };

export type UnfollowVesselMutationVariables = Exact<{
  imo: Scalars['String'];
}>;


export type UnfollowVesselMutationResult = { removeFavoriteVessel: { nope: boolean | null } | null };

export type CreateServiceInterviewMutationVariables = Exact<{
  serviceInterview: CreateServiceInterviewInput;
}>;


export type CreateServiceInterviewMutationResult = { createServiceInterview: { nope: boolean | null } | null };

export type ReachTargetMutationVariables = Exact<{
  target: InputMaybe<Scalars['String']>;
  params: InputMaybe<Scalars['GenericScalar']>;
}>;


export type ReachTargetMutationResult = { reachTarget: { reactions: any | null } | null };

export type GetReactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReactionsQueryResult = { reactions: any | null };

export type GetSubscribePushSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscribePushSettingsQueryResult = { subscribePushSettings: { serverKey: string } | null };

export type SubscribePushMutationVariables = Exact<{
  subscription: InputMaybe<PushSubscriptionInput>;
}>;


export type SubscribePushMutationResult = { subscribePush: { nope: boolean | null } | null };

export type UnsubscribePushMutationVariables = Exact<{
  subscription: InputMaybe<PushSubscriptionInput>;
}>;


export type UnsubscribePushMutationResult = { unsubscribePush: { nope: boolean | null } | null };

export type SyncNotificationSubscriptionMutationVariables = Exact<{
  subscription: InputMaybe<PushSubscriptionInput>;
}>;


export type SyncNotificationSubscriptionMutationResult = { syncPushSubscription: { remove: boolean | null } | null };

export type GetReleaseNoteListQueryVariables = Exact<{
  first: Scalars['Int'];
  after: InputMaybe<Scalars['String']>;
}>;


export type GetReleaseNoteListQueryResult = { releaseNotes: { edges: Array<{ cursor: string, node: { id: string, version: string, title: string, content: string } | null } | null>, pageInfo: { hasNextPage: boolean } } | null };

export type GetReleaseNoteQueryVariables = Exact<{
  version: Scalars['String'];
}>;


export type GetReleaseNoteQueryResult = { releaseNote: { id: string, version: string, title: string, content: string } | null };

export const AdmissionFragmentDoc = gql`
    fragment Admission on Admission {
  id
  status
  companyName
  inn
  chiefFullName
  chiefPhone
  fullName
  position
  phone
  email
  birthDate
  birthPlace
  passportSeries
  passportNumber
  passportDate
  passportIssuer
  passportDepartmentCode
  registrationAddress
  actualAddress
  carRegNumber
  carBrand
  carModel
  carColor
  carType
  passDate
  companyActivityKind
  paragraph
  accessZone1
  accessZone2
  accessZone3
}
    `;
export const GetAdmissionListDocument = gql`
    query GetAdmissionList($query: String, $isAuto: Boolean, $statuses: [Int!]) {
  admissions(query: $query, isAuto: $isAuto, statuses: $statuses) {
    id
    status
    companyName
    inn
    chiefFullName
    chiefPhone
    fullName
    position
    phone
    email
    birthDate
    birthPlace
    passportSeries
    passportNumber
    passportDate
    passportIssuer
    passportDepartmentCode
    registrationAddress
    actualAddress
    carRegNumber
    carBrand
    carModel
    carColor
    carType
    passDate
    companyActivityKind
    paragraph
    accessZone1
    accessZone2
    accessZone3
  }
}
    `;

/**
 * __useGetAdmissionListQuery__
 *
 * To run a query within a React component, call `useGetAdmissionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdmissionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdmissionListQuery({
 *   variables: {
 *      query: // value for 'query'
 *      isAuto: // value for 'isAuto'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetAdmissionListQuery(baseOptions?: Apollo.QueryHookOptions<GetAdmissionListQueryResult, GetAdmissionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdmissionListQueryResult, GetAdmissionListQueryVariables>(GetAdmissionListDocument, options);
      }
export function useGetAdmissionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdmissionListQueryResult, GetAdmissionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdmissionListQueryResult, GetAdmissionListQueryVariables>(GetAdmissionListDocument, options);
        }
export type GetAdmissionListQueryHookResult = ReturnType<typeof useGetAdmissionListQuery>;
export type GetAdmissionListLazyQueryHookResult = ReturnType<typeof useGetAdmissionListLazyQuery>;
export const CreateAdmissionDocument = gql`
    mutation CreateAdmission($admissionCar: AdmissionInput!, $admissionPedestrian: AdmissionInput!) {
  CAR: createAdmission(admission: $admissionCar, types: [CAR]) {
    admission {
      ...Admission
    }
  }
  PEDESTRIAN: createAdmission(
    admission: $admissionPedestrian
    types: [PEDESTRIAN]
  ) {
    admission {
      ...Admission
    }
  }
}
    ${AdmissionFragmentDoc}`;
export type CreateAdmissionMutationFn = Apollo.MutationFunction<CreateAdmissionMutationResult, CreateAdmissionMutationVariables>;

/**
 * __useCreateAdmissionMutation__
 *
 * To run a mutation, you first call `useCreateAdmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdmissionMutation, { data, loading, error }] = useCreateAdmissionMutation({
 *   variables: {
 *      admissionCar: // value for 'admissionCar'
 *      admissionPedestrian: // value for 'admissionPedestrian'
 *   },
 * });
 */
export function useCreateAdmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdmissionMutationResult, CreateAdmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdmissionMutationResult, CreateAdmissionMutationVariables>(CreateAdmissionDocument, options);
      }
export type CreateAdmissionMutationHookResult = ReturnType<typeof useCreateAdmissionMutation>;
export type CreateAdmissionMutationOptions = Apollo.BaseMutationOptions<CreateAdmissionMutationResult, CreateAdmissionMutationVariables>;
export const CreateCarAdmissionDocument = gql`
    mutation CreateCarAdmission($admission: AdmissionInput!) {
  CAR: createAdmission(admission: $admission, types: [CAR]) {
    admission {
      ...Admission
    }
  }
}
    ${AdmissionFragmentDoc}`;
export type CreateCarAdmissionMutationFn = Apollo.MutationFunction<CreateCarAdmissionMutationResult, CreateCarAdmissionMutationVariables>;

/**
 * __useCreateCarAdmissionMutation__
 *
 * To run a mutation, you first call `useCreateCarAdmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarAdmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarAdmissionMutation, { data, loading, error }] = useCreateCarAdmissionMutation({
 *   variables: {
 *      admission: // value for 'admission'
 *   },
 * });
 */
export function useCreateCarAdmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarAdmissionMutationResult, CreateCarAdmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarAdmissionMutationResult, CreateCarAdmissionMutationVariables>(CreateCarAdmissionDocument, options);
      }
export type CreateCarAdmissionMutationHookResult = ReturnType<typeof useCreateCarAdmissionMutation>;
export type CreateCarAdmissionMutationOptions = Apollo.BaseMutationOptions<CreateCarAdmissionMutationResult, CreateCarAdmissionMutationVariables>;
export const CreatePedestrianAdmissionDocument = gql`
    mutation CreatePedestrianAdmission($admission: AdmissionInput!) {
  PEDESTRIAN: createAdmission(admission: $admission, types: [PEDESTRIAN]) {
    admission {
      ...Admission
    }
  }
}
    ${AdmissionFragmentDoc}`;
export type CreatePedestrianAdmissionMutationFn = Apollo.MutationFunction<CreatePedestrianAdmissionMutationResult, CreatePedestrianAdmissionMutationVariables>;

/**
 * __useCreatePedestrianAdmissionMutation__
 *
 * To run a mutation, you first call `useCreatePedestrianAdmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePedestrianAdmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPedestrianAdmissionMutation, { data, loading, error }] = useCreatePedestrianAdmissionMutation({
 *   variables: {
 *      admission: // value for 'admission'
 *   },
 * });
 */
export function useCreatePedestrianAdmissionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePedestrianAdmissionMutationResult, CreatePedestrianAdmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePedestrianAdmissionMutationResult, CreatePedestrianAdmissionMutationVariables>(CreatePedestrianAdmissionDocument, options);
      }
export type CreatePedestrianAdmissionMutationHookResult = ReturnType<typeof useCreatePedestrianAdmissionMutation>;
export type CreatePedestrianAdmissionMutationOptions = Apollo.BaseMutationOptions<CreatePedestrianAdmissionMutationResult, CreatePedestrianAdmissionMutationVariables>;
export const GetAdmissionCompanyDocument = gql`
    query GetAdmissionCompany {
  admissionCompany {
    name
    inn
    chiefFullName
    chiefPhone
  }
}
    `;

/**
 * __useGetAdmissionCompanyQuery__
 *
 * To run a query within a React component, call `useGetAdmissionCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdmissionCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdmissionCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdmissionCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetAdmissionCompanyQueryResult, GetAdmissionCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdmissionCompanyQueryResult, GetAdmissionCompanyQueryVariables>(GetAdmissionCompanyDocument, options);
      }
export function useGetAdmissionCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdmissionCompanyQueryResult, GetAdmissionCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdmissionCompanyQueryResult, GetAdmissionCompanyQueryVariables>(GetAdmissionCompanyDocument, options);
        }
export type GetAdmissionCompanyQueryHookResult = ReturnType<typeof useGetAdmissionCompanyQuery>;
export type GetAdmissionCompanyLazyQueryHookResult = ReturnType<typeof useGetAdmissionCompanyLazyQuery>;
export const GetAdmissionEmployeeListDocument = gql`
    query GetAdmissionEmployeeList($query: String) {
  admissionEmployers(query: $query) {
    fullName
    passportSeries
    passportNumber
    passportIssuer
    passportDate
    birthDate
    birthPlace
    registrationAddress
    actualAddress
    phone
    email
    position
  }
}
    `;

/**
 * __useGetAdmissionEmployeeListQuery__
 *
 * To run a query within a React component, call `useGetAdmissionEmployeeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdmissionEmployeeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdmissionEmployeeListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAdmissionEmployeeListQuery(baseOptions?: Apollo.QueryHookOptions<GetAdmissionEmployeeListQueryResult, GetAdmissionEmployeeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdmissionEmployeeListQueryResult, GetAdmissionEmployeeListQueryVariables>(GetAdmissionEmployeeListDocument, options);
      }
export function useGetAdmissionEmployeeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdmissionEmployeeListQueryResult, GetAdmissionEmployeeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdmissionEmployeeListQueryResult, GetAdmissionEmployeeListQueryVariables>(GetAdmissionEmployeeListDocument, options);
        }
export type GetAdmissionEmployeeListQueryHookResult = ReturnType<typeof useGetAdmissionEmployeeListQuery>;
export type GetAdmissionEmployeeListLazyQueryHookResult = ReturnType<typeof useGetAdmissionEmployeeListLazyQuery>;
export const GetAdmissionCarListDocument = gql`
    query GetAdmissionCarList($query: String) {
  admissionCars(query: $query) {
    brand
    type
    model
    regNumber
    color
  }
}
    `;

/**
 * __useGetAdmissionCarListQuery__
 *
 * To run a query within a React component, call `useGetAdmissionCarListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdmissionCarListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdmissionCarListQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetAdmissionCarListQuery(baseOptions?: Apollo.QueryHookOptions<GetAdmissionCarListQueryResult, GetAdmissionCarListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdmissionCarListQueryResult, GetAdmissionCarListQueryVariables>(GetAdmissionCarListDocument, options);
      }
export function useGetAdmissionCarListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdmissionCarListQueryResult, GetAdmissionCarListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdmissionCarListQueryResult, GetAdmissionCarListQueryVariables>(GetAdmissionCarListDocument, options);
        }
export type GetAdmissionCarListQueryHookResult = ReturnType<typeof useGetAdmissionCarListQuery>;
export type GetAdmissionCarListLazyQueryHookResult = ReturnType<typeof useGetAdmissionCarListLazyQuery>;
export const GetVesselCallListDocument = gql`
    query GetVesselCallList($dateFrom: Date, $dateTo: Date, $status: [String!], $query: String, $favorite: Boolean, $page: String) {
  vesselCalls(
    dateFrom: $dateFrom
    dateTo: $dateTo
    status: $status
    page: $page
    favorite: $favorite
    query: $query
    offset: 20
  ) {
    vesselCalls {
      id
      date
      number
      type
      status
      vessel {
        name
        imo
      }
      arrival {
        date
        type
        voyage
      }
      departure {
        date
        type
        voyage
      }
      favorite
    }
    emptyFavorites
    pageInfo {
      countItems
      nextPage
      pageSize
    }
  }
}
    `;

/**
 * __useGetVesselCallListQuery__
 *
 * To run a query within a React component, call `useGetVesselCallListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVesselCallListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVesselCallListQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      status: // value for 'status'
 *      query: // value for 'query'
 *      favorite: // value for 'favorite'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetVesselCallListQuery(baseOptions?: Apollo.QueryHookOptions<GetVesselCallListQueryResult, GetVesselCallListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVesselCallListQueryResult, GetVesselCallListQueryVariables>(GetVesselCallListDocument, options);
      }
export function useGetVesselCallListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVesselCallListQueryResult, GetVesselCallListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVesselCallListQueryResult, GetVesselCallListQueryVariables>(GetVesselCallListDocument, options);
        }
export type GetVesselCallListQueryHookResult = ReturnType<typeof useGetVesselCallListQuery>;
export type GetVesselCallListLazyQueryHookResult = ReturnType<typeof useGetVesselCallListLazyQuery>;
export const GetVesselCallDocument = gql`
    query GetVesselCall($id: String!) {
  vesselCall(id: $id) {
    id
    date
    number
    type
    status
    vessel {
      name
      imo
      callSign
      line
      length
    }
    arrival {
      date
      type
      voyage
      line
      port {
        code
        name
      }
    }
    departure {
      date
      type
      voyage
      line
      port {
        code
        name
      }
    }
    operations {
      date
      operation
      terminal
      berth
    }
    favorite
  }
}
    `;

/**
 * __useGetVesselCallQuery__
 *
 * To run a query within a React component, call `useGetVesselCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVesselCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVesselCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVesselCallQuery(baseOptions: Apollo.QueryHookOptions<GetVesselCallQueryResult, GetVesselCallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVesselCallQueryResult, GetVesselCallQueryVariables>(GetVesselCallDocument, options);
      }
export function useGetVesselCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVesselCallQueryResult, GetVesselCallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVesselCallQueryResult, GetVesselCallQueryVariables>(GetVesselCallDocument, options);
        }
export type GetVesselCallQueryHookResult = ReturnType<typeof useGetVesselCallQuery>;
export type GetVesselCallLazyQueryHookResult = ReturnType<typeof useGetVesselCallLazyQuery>;
export const FollowVesselDocument = gql`
    mutation FollowVessel($imo: String!) {
  addFavoriteVessel(imo: $imo) {
    nope
  }
}
    `;
export type FollowVesselMutationFn = Apollo.MutationFunction<FollowVesselMutationResult, FollowVesselMutationVariables>;

/**
 * __useFollowVesselMutation__
 *
 * To run a mutation, you first call `useFollowVesselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowVesselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followVesselMutation, { data, loading, error }] = useFollowVesselMutation({
 *   variables: {
 *      imo: // value for 'imo'
 *   },
 * });
 */
export function useFollowVesselMutation(baseOptions?: Apollo.MutationHookOptions<FollowVesselMutationResult, FollowVesselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowVesselMutationResult, FollowVesselMutationVariables>(FollowVesselDocument, options);
      }
export type FollowVesselMutationHookResult = ReturnType<typeof useFollowVesselMutation>;
export type FollowVesselMutationOptions = Apollo.BaseMutationOptions<FollowVesselMutationResult, FollowVesselMutationVariables>;
export const UnfollowVesselDocument = gql`
    mutation UnfollowVessel($imo: String!) {
  removeFavoriteVessel(imo: $imo) {
    nope
  }
}
    `;
export type UnfollowVesselMutationFn = Apollo.MutationFunction<UnfollowVesselMutationResult, UnfollowVesselMutationVariables>;

/**
 * __useUnfollowVesselMutation__
 *
 * To run a mutation, you first call `useUnfollowVesselMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowVesselMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowVesselMutation, { data, loading, error }] = useUnfollowVesselMutation({
 *   variables: {
 *      imo: // value for 'imo'
 *   },
 * });
 */
export function useUnfollowVesselMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowVesselMutationResult, UnfollowVesselMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowVesselMutationResult, UnfollowVesselMutationVariables>(UnfollowVesselDocument, options);
      }
export type UnfollowVesselMutationHookResult = ReturnType<typeof useUnfollowVesselMutation>;
export type UnfollowVesselMutationOptions = Apollo.BaseMutationOptions<UnfollowVesselMutationResult, UnfollowVesselMutationVariables>;
export const CreateServiceInterviewDocument = gql`
    mutation CreateServiceInterview($serviceInterview: CreateServiceInterviewInput!) {
  createServiceInterview(serviceInterview: $serviceInterview) {
    nope
  }
}
    `;
export type CreateServiceInterviewMutationFn = Apollo.MutationFunction<CreateServiceInterviewMutationResult, CreateServiceInterviewMutationVariables>;

/**
 * __useCreateServiceInterviewMutation__
 *
 * To run a mutation, you first call `useCreateServiceInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceInterviewMutation, { data, loading, error }] = useCreateServiceInterviewMutation({
 *   variables: {
 *      serviceInterview: // value for 'serviceInterview'
 *   },
 * });
 */
export function useCreateServiceInterviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceInterviewMutationResult, CreateServiceInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceInterviewMutationResult, CreateServiceInterviewMutationVariables>(CreateServiceInterviewDocument, options);
      }
export type CreateServiceInterviewMutationHookResult = ReturnType<typeof useCreateServiceInterviewMutation>;
export type CreateServiceInterviewMutationOptions = Apollo.BaseMutationOptions<CreateServiceInterviewMutationResult, CreateServiceInterviewMutationVariables>;
export const ReachTargetDocument = gql`
    mutation ReachTarget($target: String, $params: GenericScalar) {
  reachTarget(target: $target, params: $params) {
    reactions
  }
}
    `;
export type ReachTargetMutationFn = Apollo.MutationFunction<ReachTargetMutationResult, ReachTargetMutationVariables>;

/**
 * __useReachTargetMutation__
 *
 * To run a mutation, you first call `useReachTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReachTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reachTargetMutation, { data, loading, error }] = useReachTargetMutation({
 *   variables: {
 *      target: // value for 'target'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useReachTargetMutation(baseOptions?: Apollo.MutationHookOptions<ReachTargetMutationResult, ReachTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReachTargetMutationResult, ReachTargetMutationVariables>(ReachTargetDocument, options);
      }
export type ReachTargetMutationHookResult = ReturnType<typeof useReachTargetMutation>;
export type ReachTargetMutationOptions = Apollo.BaseMutationOptions<ReachTargetMutationResult, ReachTargetMutationVariables>;
export const GetReactionsDocument = gql`
    query GetReactions {
  reactions
}
    `;

/**
 * __useGetReactionsQuery__
 *
 * To run a query within a React component, call `useGetReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetReactionsQueryResult, GetReactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReactionsQueryResult, GetReactionsQueryVariables>(GetReactionsDocument, options);
      }
export function useGetReactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReactionsQueryResult, GetReactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReactionsQueryResult, GetReactionsQueryVariables>(GetReactionsDocument, options);
        }
export type GetReactionsQueryHookResult = ReturnType<typeof useGetReactionsQuery>;
export type GetReactionsLazyQueryHookResult = ReturnType<typeof useGetReactionsLazyQuery>;
export const GetSubscribePushSettingsDocument = gql`
    query GetSubscribePushSettings {
  subscribePushSettings {
    serverKey
  }
}
    `;

/**
 * __useGetSubscribePushSettingsQuery__
 *
 * To run a query within a React component, call `useGetSubscribePushSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscribePushSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscribePushSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscribePushSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscribePushSettingsQueryResult, GetSubscribePushSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscribePushSettingsQueryResult, GetSubscribePushSettingsQueryVariables>(GetSubscribePushSettingsDocument, options);
      }
export function useGetSubscribePushSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscribePushSettingsQueryResult, GetSubscribePushSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscribePushSettingsQueryResult, GetSubscribePushSettingsQueryVariables>(GetSubscribePushSettingsDocument, options);
        }
export type GetSubscribePushSettingsQueryHookResult = ReturnType<typeof useGetSubscribePushSettingsQuery>;
export type GetSubscribePushSettingsLazyQueryHookResult = ReturnType<typeof useGetSubscribePushSettingsLazyQuery>;
export const SubscribePushDocument = gql`
    mutation SubscribePush($subscription: PushSubscriptionInput) {
  subscribePush(subscription: $subscription) {
    nope
  }
}
    `;
export type SubscribePushMutationFn = Apollo.MutationFunction<SubscribePushMutationResult, SubscribePushMutationVariables>;

/**
 * __useSubscribePushMutation__
 *
 * To run a mutation, you first call `useSubscribePushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribePushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribePushMutation, { data, loading, error }] = useSubscribePushMutation({
 *   variables: {
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useSubscribePushMutation(baseOptions?: Apollo.MutationHookOptions<SubscribePushMutationResult, SubscribePushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribePushMutationResult, SubscribePushMutationVariables>(SubscribePushDocument, options);
      }
export type SubscribePushMutationHookResult = ReturnType<typeof useSubscribePushMutation>;
export type SubscribePushMutationOptions = Apollo.BaseMutationOptions<SubscribePushMutationResult, SubscribePushMutationVariables>;
export const UnsubscribePushDocument = gql`
    mutation UnsubscribePush($subscription: PushSubscriptionInput) {
  unsubscribePush(subscription: $subscription) {
    nope
  }
}
    `;
export type UnsubscribePushMutationFn = Apollo.MutationFunction<UnsubscribePushMutationResult, UnsubscribePushMutationVariables>;

/**
 * __useUnsubscribePushMutation__
 *
 * To run a mutation, you first call `useUnsubscribePushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribePushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribePushMutation, { data, loading, error }] = useUnsubscribePushMutation({
 *   variables: {
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useUnsubscribePushMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribePushMutationResult, UnsubscribePushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribePushMutationResult, UnsubscribePushMutationVariables>(UnsubscribePushDocument, options);
      }
export type UnsubscribePushMutationHookResult = ReturnType<typeof useUnsubscribePushMutation>;
export type UnsubscribePushMutationOptions = Apollo.BaseMutationOptions<UnsubscribePushMutationResult, UnsubscribePushMutationVariables>;
export const SyncNotificationSubscriptionDocument = gql`
    mutation SyncNotificationSubscription($subscription: PushSubscriptionInput) {
  syncPushSubscription(subscription: $subscription) {
    remove
  }
}
    `;
export type SyncNotificationSubscriptionMutationFn = Apollo.MutationFunction<SyncNotificationSubscriptionMutationResult, SyncNotificationSubscriptionMutationVariables>;

/**
 * __useSyncNotificationSubscriptionMutation__
 *
 * To run a mutation, you first call `useSyncNotificationSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncNotificationSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncNotificationSubscriptionMutation, { data, loading, error }] = useSyncNotificationSubscriptionMutation({
 *   variables: {
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useSyncNotificationSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<SyncNotificationSubscriptionMutationResult, SyncNotificationSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncNotificationSubscriptionMutationResult, SyncNotificationSubscriptionMutationVariables>(SyncNotificationSubscriptionDocument, options);
      }
export type SyncNotificationSubscriptionMutationHookResult = ReturnType<typeof useSyncNotificationSubscriptionMutation>;
export type SyncNotificationSubscriptionMutationOptions = Apollo.BaseMutationOptions<SyncNotificationSubscriptionMutationResult, SyncNotificationSubscriptionMutationVariables>;
export const GetReleaseNoteListDocument = gql`
    query GetReleaseNoteList($first: Int!, $after: String) {
  releaseNotes(first: $first, after: $after) {
    edges {
      node {
        id
        version
        title
        content
      }
      cursor
    }
    pageInfo {
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetReleaseNoteListQuery__
 *
 * To run a query within a React component, call `useGetReleaseNoteListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReleaseNoteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReleaseNoteListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetReleaseNoteListQuery(baseOptions: Apollo.QueryHookOptions<GetReleaseNoteListQueryResult, GetReleaseNoteListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReleaseNoteListQueryResult, GetReleaseNoteListQueryVariables>(GetReleaseNoteListDocument, options);
      }
export function useGetReleaseNoteListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReleaseNoteListQueryResult, GetReleaseNoteListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReleaseNoteListQueryResult, GetReleaseNoteListQueryVariables>(GetReleaseNoteListDocument, options);
        }
export type GetReleaseNoteListQueryHookResult = ReturnType<typeof useGetReleaseNoteListQuery>;
export type GetReleaseNoteListLazyQueryHookResult = ReturnType<typeof useGetReleaseNoteListLazyQuery>;
export const GetReleaseNoteDocument = gql`
    query GetReleaseNote($version: String!) {
  releaseNote(version: $version) {
    id
    version
    title
    content
  }
}
    `;

/**
 * __useGetReleaseNoteQuery__
 *
 * To run a query within a React component, call `useGetReleaseNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReleaseNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReleaseNoteQuery({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetReleaseNoteQuery(baseOptions: Apollo.QueryHookOptions<GetReleaseNoteQueryResult, GetReleaseNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReleaseNoteQueryResult, GetReleaseNoteQueryVariables>(GetReleaseNoteDocument, options);
      }
export function useGetReleaseNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReleaseNoteQueryResult, GetReleaseNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReleaseNoteQueryResult, GetReleaseNoteQueryVariables>(GetReleaseNoteDocument, options);
        }
export type GetReleaseNoteQueryHookResult = ReturnType<typeof useGetReleaseNoteQuery>;
export type GetReleaseNoteLazyQueryHookResult = ReturnType<typeof useGetReleaseNoteLazyQuery>;